export default "__VITE_ASSET__DkBkC6xP__"